/**
 * Announcement Bar Manager - Moon Moon Agency
 * Fermeture de la barre d'annonces, memorisee pour la session (sessionStorage).
 *
 * Aux chargements suivants, le script inline de theme.liquid pose la classe
 * .mm-announcement-closed sur <html> avant le rendu : la barre n'apparait pas.
 */

/*********************************************************************************************
 * 📢 ANNOUNCEMENT BAR MANAGER
 */
const AnnouncementBarManager = {
	config: {
		selectors: {
			bar: '[data-announce-bar]',
			close: '[data-announce-close]',
		},
		storageKey: 'mm-announcement-closed', // Meme cle que le script inline de theme.liquid
	},

	/**
	 * Initialize the module
	 */
	init() {
		const bar = window.getElement(this.config.selectors.bar);
		if (!bar) return; // Guard clause : section absente (ex. desactivee sur ce template)

		this._bindEvents();
		window.log('info', '📢 [ANNOUNCEMENT_BAR]', 'Initialized');
	},

	_bindEvents() {
		// Delegation : la barre peut etre re-rendue par l'editeur de theme
		document.addEventListener('click', (e) => {
			const trigger = e.target.closest(this.config.selectors.close);
			if (!trigger) return;
			this.close(trigger.closest(this.config.selectors.bar));
		});
	},

	/**
	 * Masque la barre et libere la hauteur reservee par le layout.
	 * @param {HTMLElement} bar - Le conteneur [data-announce-bar]
	 */
	close(bar) {
		if (!bar) return;

		bar.hidden = true;

		// --announcement-bar-height alimente --hero-height : la remise a zero
		// doit se faire sur :root, sinon le hero garde 30px de trop.
		// La classe (meme que le script inline de theme.liquid) rend aussi au
		// premier hero son ancrage de scroll-snap (voir mm-hero.css).
		const root = document.documentElement;
		root.classList.add('mm-announcement-closed');
		root.style.setProperty('--announcement-bar-height', '0px');
		root.style.setProperty('--announcement-bar-height-mobile', '0px');

		// try/catch : sessionStorage peut lever (navigation privee, cookies bloques)
		try {
			sessionStorage.setItem(this.config.storageKey, '1');
		} catch (e) {}

		window.emit('global:announcement-closed');
		window.log('info', '📢 [ANNOUNCEMENT_BAR]', 'Closed');
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => AnnouncementBarManager.init());
} else {
	AnnouncementBarManager.init();
}

// Re-init sur rechargement de section depuis l'editeur de theme
document.addEventListener('shopify:section:load', () => AnnouncementBarManager.init());
